import { RestClient } from '@/api/rest-client'
import { Dashboard } from '@/api/model/dashboard'
import { Company } from '@/api/model/company'
import { cloneDeep } from 'lodash'

export class DashboardClient extends RestClient<Dashboard> {
    collectionName = 'dashboards'
    parseData = Dashboard.fromData

    async create(data: Dashboard): Promise<Dashboard> {
        const request = cloneDeep<any>(data)

        if (data.company instanceof Company) {
            request.company = data.company.resourceIdentifier
        }

        return super.create(request)
    }

    protected handleError(error: any) {
        throw error
    }
}
